import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { logoutUser } from '../../util/APIUtils';
import '../../styling/CommonPage.css';

const UnauthorizedPage = ({ userRoles }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state?.message || "Unauthorized - You do not have permission to view this page";

  useEffect(() => {
    const roles = Array.isArray(userRoles) ? userRoles : [];

    const timer = setTimeout(async () => {
      // If basic/unknown user -> logout to a public route
      if (roles.length === 0 || (roles.length === 1 && roles.includes("USER"))) {
        try {
          await logoutUser();                  // if this doesn't navigate on its own
        } finally {
          navigate('/login', { replace: true });
        }
      } else {
        // Otherwise send them somewhere safe (make sure it's public or permitted)
        navigate('/', { replace: true });
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, userRoles]);

  const handleBackToLogin = async () => {
    try {
      await logoutUser();                      // if logoutUser already redirects, you can remove the next line
    } finally {
      navigate('/login', { replace: true });
    }
  };

  return (
    <div className="page-container">
      <h1 className="page-title">403</h1>
      <div className="page-desc">{message}</div>
      <div className="redirect-message">You will be redirected shortly...</div>

      <button
        className="go-home-btn"
        type="button"
        onClick={handleBackToLogin}            // always enabled
      >
        Go to Login
      </button>
    </div>
  );
};

export default UnauthorizedPage;
